import { lightOrDark, hexToHSL, HSLToHex } from './helpers';
type LightOrDarkFn = (input: string) => string;

export function handleLightOrDark(
	input: string,
	isLight: LightOrDarkFn,
	isDark: LightOrDarkFn
) {
	if (lightOrDark(input) === 'light') {
		return isLight(input);
	} else {
		return isDark(input);
	}
}

export function lighten10(H: string) {
	const { h, s, l } = hexToHSL(H);
	const lightened = l + 10 >= 100 ? 100 : l + 10;
	return HSLToHex(h, s, lightened);
}

export function darken10(H: string) {
	const { h, s, l } = hexToHSL(H);
	const darkened = l - 10 <= 0 ? 0 : l - 10;
	return HSLToHex(h, s, darkened);
}
